import React, { useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { motion } from 'framer-motion';

export default function ConfigDisplay({ config, onRemove }) {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(config.string);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const getBadgeStyles = (type) => {
    switch (type) {
      case 'vless': return 'bg-purple-900/50 text-purple-400';
      case 'vmess': return 'bg-blue-900/50 text-blue-400';
      case 'reality': return 'bg-emerald-900/50 text-emerald-400';
      case 'happ': return 'bg-cyan-900/50 text-cyan-400 border border-cyan-500/30';
      default: return 'bg-gray-800 text-gray-400';
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      className="bg-gray-800 rounded-xl border border-gray-700 overflow-hidden shadow-lg mt-4"
    >
      <div className="flex justify-between items-center px-4 py-3 bg-gray-900 border-b border-gray-700">
        <div className="flex items-center space-x-3">
          <span className={`px-2 py-1 text-[10px] font-black rounded-md uppercase tracking-tighter ${getBadgeStyles(config.type)}`}>
            {config.type}
          </span>
          <span className="font-medium text-sm text-gray-200 truncate max-w-[150px] md:max-w-none">{config.name}</span>
        </div>
        <button onClick={onRemove} className="text-gray-500 hover:text-red-400 transition-colors">
          <SafeIcon icon={FiIcons.FiTrash2} />
        </button>
      </div>
      <div className="p-4">
        <div className="relative">
          <textarea
            readOnly
            value={config.string}
            className="w-full bg-gray-950 text-gray-300 font-mono text-[11px] p-4 rounded-lg border border-gray-800 h-24 resize-none outline-none break-all"
          />
          <button
            onClick={handleCopy}
            className={`absolute top-2 right-2 p-2 rounded-md flex items-center space-x-1 transition-colors ${
              copied ? 'bg-green-600 text-white' : 'bg-gray-800 text-gray-400 hover:bg-gray-700'
            }`}
          >
            {copied ? (
              <>
                <SafeIcon icon={FiIcons.FiCheck} size={14} />
                <span className="text-xs">Copied</span>
              </>
            ) : (
              <>
                <SafeIcon icon={FiIcons.FiCopy} size={14} />
                <span className="text-xs">Copy</span>
              </>
            )}
          </button>
        </div>
        {config.type === 'happ' && (
          <div className="mt-2 flex items-center gap-1.5 text-[10px] text-cyan-500/70 font-bold uppercase tracking-widest">
            <SafeIcon icon={FiIcons.FiLock} size={10} />
            Encrypted Crypt5 Format
          </div>
        )}
      </div>
    </motion.div>
  );
}